module.exports = __webpack_public_path__ + "media/video.fca203ca.mp4";